import React, { Component } from 'react';
import { connect } from 'react-redux';

import { updateFlightSearchParms } from '../redux/actions/FlightsUiActions';

export default function withFlightSeacrhParams(WrappedComp) {
  class FlightSearchParams extends Component {
    render() {
      return <WrappedComp {...this.props} />;
    }
  }

  const mapStateToProps = ({ flightsUi }) => ({
    searchParams: flightsUi.searchParams,
  });

  const mapDispatchToProps = dispatch => ({
    updateFlightSearchParms: ({ parameter, value }) =>
      dispatch(updateFlightSearchParms({ parameter, value })),
  });

  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(FlightSearchParams);
}



// WEBPACK FOOTER //
// ./src/HOCs/withFlightSearchParams.jsx